<template>
  <div class="form-container">
    <div v-if="asAnswer">
      <i
        class="fa-star text-cr-red"
        :class="{ far: choice > newValue, fa: choice <= newValue, 'item-small': small }"
        v-for="choice in choices"
        :key="choice"
      />
    </div>

    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      :class="{ hover: hover }"
    >
      <div class="d-flex flex-column">
        <div class="d-flex flex-nowrap">
          <i
            class="fa-star text-cr-red"
            :class="{ far: choice > newValue, fa: choice <= newValue }"
            v-for="(choice, index) in choices"
            @mouseover="setNewValue(choice)"
            @mouseout="unsetNewValue()"
            @click="storeNewValue(choice)"
            :key="choice"
            :id="itemId(index)"
          ></i>
        </div>
        <div
          class="d-flex justify-content-between align-items-center mt-2"
          style="height: 35px;"
        >
          <div class="help-text font-italic">
            {{ researchItem.item.config.min_text || ' ' }}
          </div>
          <div
            class="d-flex align-items-center justify-content-center number"
          >
            <div
              v-if="newValue"
              class="badge badge-dark bg-cr-red-black"
            >
              <div class="badge-number">
                {{ newValue }}
              </div>
            </div>
          </div>
          <div class="help-text font-italic text-right">
            {{ researchItem.item.config.max_text || ' ' }}
          </div>
        </div>
      </div>
    </div>

    <v-numeric-average
      v-if="showAverage"
      :value="researchItem.answer.value"
      :average="researchItem.average"
    />
  </div>
</template>

<script>

import NumericAverage from '@/reviewer/components/items/snippets/NumericAverage.vue';
import { GenericItemMixin } from '@/reviewer/mixins';

export default {
  name: 'ItemStars',
  components: {
    'v-numeric-average': NumericAverage,
  },
  mixins: [
    GenericItemMixin,
  ],
  props: {
    showAverage: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      newValue: this.researchItem.answer.value,
      choices: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      hover: false,
    };
  },
  methods: {
    itemId(index) {
      return this.idPrefix ? `${this.idPrefix}-item-stars-${index}` : `item-stars-${index}`;
    },
    setNewValue(val) {
      this.hover = true;
      this.newValue = val;
    },
    unsetNewValue() {
      this.hover = false;
      this.newValue = this.researchItem.answer.value;
    },
    storeNewValue(val) {
      this.hover = false;
      this.researchItem.answer.value = val;
      this.newValue = val;
      this.$emit('value-changed');
    },
  },
};
</script>

<style scoped>
.fa-star {
  font-size: 25px;
  padding: 10px;
}

.hover .fa, .hover .far {
  color: rgba(226, 44, 48, 0.4);
}

.number {
  width: 50px;
  font-size: 20px;
}

i.item-small {
  font-size: 15px;
  padding: 5px;
}

.help-text {
  width: 200px;
}

@media screen and (max-width: 500px) {
  .fa-star {
    font-size: 15px;
    padding: 5px;
  }

  .number {
    width: 30px;
    font-size: 14px;
  }

  .help-text {
    width: 120px;
    font-size: 11px;
  }

}
</style>
